let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fno83")).then(() => parcelRequire('4jimO'));